export default function CropData({ cropData, isDemoUser }) {
  if (!Object.keys(cropData).length) {
    return <p className="ml-[30px] ">No Crop data for this parcel</p>;
  }

  // Transform the data to include year and crop info
  const transformedData = Object.keys(cropData).reduce((acc, year) => {
    // Process each year and its corresponding crop data
    const yearData = cropData[year]; // Access the first item (the crop data array for that year)
    const yearTransformed = Object.keys(yearData).reduce((yearAcc, key) => {
      const newKey = key.replace(/_/g, ' '); // Replace underscores with spaces
      const value = parseFloat(yearData[key].toFixed(2));

      // Check if percentage is less than 5
      if (value < 5) {
        yearAcc['Other (sum of <5% coverage classes)'] = (yearAcc['Other (sum of <5% coverage classes)'] || 0) + value; // Accumulate values for "Other (sum of <5% coverage classes)"
      } else {
        yearAcc[newKey] = value; // Replace the key with spaces
      }

      return yearAcc;
    }, {});

    // If "Other (sum of <5% coverage classes)" exists, add it to the transformed year data
    if (yearTransformed['Other (sum of <5% coverage classes)']) {
      yearTransformed['Other (sum of <5% coverage classes)'] = parseFloat(yearTransformed['Other (sum of <5% coverage classes)'].toFixed(2)); // Round to 2 decimal places
    }

    acc[year] = yearTransformed; // Add year data to accumulator
    return acc;
  }, {});

  // Sorting and adjusting for the "Other (sum of <5% coverage classes)" field
  const sortedData = Object.keys(transformedData)
    .map((year) => {
      const yearData = transformedData[year];
      const sortedArray = Object.entries(yearData)
        .filter(([key]) => key !== 'Other (sum of <5% coverage classes)')
        .sort(([, valueA], [, valueB]) => valueB - valueA);

      const sortedObject = {
        ...Object.fromEntries(sortedArray),
        'Other (sum of <5% coverage classes)': yearData['Other (sum of <5% coverage classes)'],
      };

      // Calculate the total and adjust "Other (sum of <5% coverage classes)" if necessary
      const totalSum = Object.values(sortedObject).reduce(
        (acc, curr) => acc + curr,
        0
      );

      if (totalSum > 100) {
        const maxOther = 100 - (totalSum - sortedObject['Other (sum of <5% coverage classes)']);
        sortedObject['Other (sum of <5% coverage classes)'] = Math.min(maxOther, sortedObject['Other (sum of <5% coverage classes)']).toFixed(2);
      }

      return { year, data: sortedObject };
    })
    .sort((a, b) => b.year - a.year); // Sort the years in descending order (most recent first)

  return (
    <>
      {sortedData.length ? (
        <div key={sortedData[0].year}>
          {/* <h3 className="mt-3 ml-10">{sortedData[0].year}</h3> */}
          <table className="mb-5" style={{ width: '100%', tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ paddingLeft: '50px', width: '25%', textAlign: 'left' }}></th>
                <th style={{ width: '25%', textAlign: 'left' }}></th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(sortedData[0].data).map(([crop, percentage]) => (
                <tr key={crop}>
                  <td className="items-center" style={{ paddingLeft: '50px', textAlign: 'left' }}>
                    <span className={`${isDemoUser ? 'blur' : ''}`}>{crop}</span>
                  </td>
                  <td className="items-center" style={{ textAlign: 'left' }}>
                    <span className={`${isDemoUser ? 'blur' : ''}`}>{percentage} %</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="ml-[30px] ">No Crop data for this parcel</p>
      )}
    </>
  );
}
